// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-outline"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 6.5V20L9 17.5L15 21L21 17.5V4L15 6.5L9 3L3 6.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 6.5V20L9 17.5L15 21L21 17.5V4L15 6.5L9 3L3 6.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-outline')
export default class MapOutlineIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-outline',
    }
  }
}
